import { Col, Container, Row } from "react-bootstrap";
import { applyPrecision } from "../../shared/helpers/helpers";
import Chart from "../Chart/Chart";

interface Props {
    xValues?: Array<string | number>;
    yValues?: Array<number>;
    title?: string;
    unit?: string;
    displayUnit?: boolean;
}

const ChartContainer = ({ title, xValues, yValues, unit, displayUnit }: Props) => {

    function onHover(x: string | number, y: number) { }

    function getTotal(): number | null {
        const total = yValues?.reduce((acc, iterator) => acc + iterator, 0);
        const roundedTotal = applyPrecision(total as number, 2);
        return roundedTotal;
    }

    return (
        <div>
            <Container className="position-relative w-100">
                <Row className="d-flex align-items-center justify-content-center w-100">
                    <Row className="d-flex justify-content-between w-100 position-absolute top-0" style={{ fontSize: ".9rem" }}>
                        <Col sm="auto" className="d-flex justify-content-start w-auto" style={{ fontWeight: "bold" }}>{title}</Col>
                        {yValues?.length && <Col sm="auto" className="d-flex justify-content-end w-auto">{getTotal()} {unit}</Col>}
                    </Row>
                    <Row className="d-flex justify-content-center">
                        <Chart xValues={xValues} yValues={yValues} unit={unit} displayUnit={displayUnit} onHover={onHover} />
                    </Row>
                </Row>
            </Container>
        </div>
    )
}

export default ChartContainer